import React, { useEffect, useRef, useState } from "react";
import MobileIcon from "../../../assets/icons/ABHA-icons/mobile-icon";
import axios from "axios";
import errorToast from "../../helper-components/error-toast";
import { url } from "../../../redux/config";
import successToast from "../../helper-components/success-toast";
import AddButton from "../../buttons/button";
import { handleShowErrorToast } from "../../helper-components/helper-function";
import InputField from "../../forms/input-field";
import { Upload, Check, RefreshCw } from "lucide-react";
import LeftArrowIcon from "../../../assets/icons/ABHA-icons/left-arrow-icon";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import ClockIcon from "../../../assets/icons/ABHA-icons/clock-icon";
import ResendIcon from "../../../assets/icons/ABHA-icons/resend-icon";
import InfoIcon from "../../../assets/icons/ABHA-icons/info-icon";

function OTP({
  txnId,
  adhaarNo,
  adhaarAccessToken,
  setTxnId,
  message,
  setmessage,
  setMethod,
  setStatus,
  setPosition,
  tokenExpiresIn,
  closeModal,
  setAdhaarSuccessData,
  setAdhaarX_Token,
  setABHAlist,
}) {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(tokenExpiresIn || 1800); // 2:00 in seconds
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [base64Data, setBase64Data] = useState("");

  const inputRefs = useRef([]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  const handleInputChange = (index, value) => {
    if (value.length > 1) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);
  // useEffect(() => {
  //   sendOtpWithAadhaar(adhaarAccessToken, adhaarNo);
  // }, [adhaarNo, adhaarAccessToken]);

  const verifyOTP = async () => {
    setSubmitted(true);
    const enteredCode = code.join("");

    if (enteredCode.length !== 6) return errorToast("Enter Complete OTP");
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/verify-abha-using-mobile`,
        {
          txnId: txnId,
          otp: enteredCode,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(
        "*******************************************,accounts",
        response?.data?.data?.abdmResponse?.accounts
      );

      console.log("Response:", response);
      successToast("OTP is verified");
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      //   setmessage(response?.data?.data?.abdmResponse?.message);
      console.log(
        "*******************************************,accounts",
        response?.data?.data?.abdmResponse?.accounts
      );
      setABHAlist(response?.data?.data?.abdmResponse?.accounts);
      setAdhaarSuccessData(response?.data?.data?.abdmResponse?.ABHAProfile);
      console.log(response?.data?.data?.abdmResponse?.message);
      setStatus("list");
      //   setPosition(3);

      setLoading(false);
      //   setPopUp(true);

      return response.data;
    } catch (error) {
      console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
      errorToast(error?.response?.data?.message);
      console.error(
        "Error verifying OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
      // throw error;
    }
  };
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      //   validationSchema={validationSchema}
      onSubmit={verifyOTP}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form className="flex flex-col h-full">
          <div className="flex-1 mt-6 h-full flex flex-col gap-6">
            <div
              onClick={() => {
                setStatus("Mobile Number");
                setPosition(1);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              className="flex flex-row gap-2 items-center cursor-pointer "
            >
              <LeftArrowIcon />
              <label
                className={`
                cursor-pointer text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
              >
                Back
              </label>
            </div>
            <div className="flex flex-col items-center gap-4">
              <div
                className={`rounded-full w-16 h-16 flex justify-center items-center bg-[var(--abha-otp-bg)]`}
              >
                <MobileIcon />
              </div>

              <div>
                <label
                  className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-button-fs)] font-[var(--abha-method-card-button-fw)] whitespace-nowrap`}
                >
                  {message}
                  {console.log("...................", message)}
                </label>
                <div className="mb-6 flex flex-col gap-3 items-center mt-6">
                  <label
                    className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-fw)] whitespace-nowrap`}
                  >
                    Enter 6-digit OTP
                  </label>
                  <div className="flex justify-between mb-4 w-min gap-3">
                    {code.map((digit, index) => (
                      <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)}
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) =>
                          handleInputChange(index, e.target.value)
                        }
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        className={`w-12 h-12 text-center text-lg font-semibold rounded-lg focus:outline-none transition-colors
        ${
          submitted && digit === ""
            ? "border-[var(--dashboard-danger)] border-2"
            : "border-[var(--customer-business-border)] border-2 "
        }`}
                        placeholder=""
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-between w-full">
              <div className="flex flex-row gap-2">
                <ClockIcon />{" "}
                <label
                  className={`
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                >
                  OTP expires in
                </label>
                <span
                  className={`text-[var(--dashboard-danger)] text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                >
                  {formatTime(timeLeft)}
                </span>
              </div>
              {/* <div className="flex flex-row gap-2">
                <ResendIcon />
                <label
                  className="text-[var(--primary)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
                "
                >
                  Resend OTP
                </label>
              </div> */}
            </div>
            <div className="border flex flex-col bg-[var(--abha-caution-bg)] border-[var(--primary)] rounded-lg  gap-[10px] p-5">
              <div className=" flex flex-row gap-[10px]">
                <InfoIcon />
                <ul className="flex flex-col gap-2">
                  <label
                    className={`
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap `}
                  >
                    Security Tips:
                  </label>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    Never share your OTP with anyone
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    OTP is valid for limited time only
                  </li>
                  <li
                    className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                    key="q"
                  >
                    If you didn't request this OTP, please ignore
                  </li>
                </ul>
              </div>
            </div>

            <div className="flex flex-row gap-3 justify-end  sticky bg-white py-4 mt-auto ">
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                onclkFn={() => closeModal()}
                text={<span>Cancel</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
              <AddButton
                prefixIcon={false}
                loading={loading}
                // ref={submitRef}
                onclkFn={() => handleShowErrorToast(errors)}
                text={<span>Verify OTP</span>}
                className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="submit"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default OTP;
